import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CartService } from '../../services/cart.service';
import { Product } from '../../interfaces/product';
import { WishlistService } from '../../services/wishlist.service';
import { CompareService } from '../../services/compare.service';
import { QuickviewService } from '../../services/quickview.service';
import { RootService } from '../../services/root.service';
import { CurrencyService } from '../../services/currency.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../../auth.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Observable, timer } from 'rxjs';

@Component({
    selector: 'app-custom-product-card',
    templateUrl: './custom-product-card.component.html',
    styleUrls: ['./custom-product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomProductCardComponent implements OnInit, OnDestroy {
    private destroy$: Subject<void> = new Subject();

    @Input() product: any;
    @Input() layout: 'grid-sm'|'grid-nl'|'grid-lg'|'list'|'horizontal'|null = null;
    @Input() enableFlashSale: boolean = true;
    fiat$;

    addingToCart = false;
    addingToWishlist = false;
    addingToCompare = false;
    showingQuickview = false;
    lang = "";

    attributeList: any[] = [];
    counter$: Observable<number>;
    count = null;
    day = false;
    fiatPrice = "";

    constructor(
        private cd: ChangeDetectorRef,
        public root: RootService,
        public cart: CartService,
        public wishlist: WishlistService,
        public compare: CompareService,
        public quickview: QuickviewService,
        public currency: CurrencyService,
        private translate: TranslateService,
        public authService: AuthService
    ) {
      //translate.setDefaultLang(translate.getBrowserLang());
    }

    ngOnInit() {
        this.lang = this.authService.getLocale();
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
          this.lang = event.lang;
          try{
            this.cd.detectChanges();
          }catch(err){

          }
        });

        this.currency.changes$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.cd.markForCheck();
        });

        this.product.productAttributeList.forEach(pa => {
          if(pa.attributeValue && pa.attributeValue.attribute && pa.attributeValue.attribute.id){
            if(this.attributeList.length == 0){
              var attr = pa.attributeValue.attribute;
              this.attributeList.push(attr);
            }else{
              var found = false;
              this.attributeList.forEach((a, index) => {
                if(a.id == pa.attributeValue.attribute.id){
                  found = true;
                }else if(!found && a.id != pa.attributeValue.attribute.id && index == this.attributeList.length - 1){
                  var attr = pa.attributeValue.attribute;
                  this.attributeList.push(attr);
                }
              });
            }
          }
        });

        try{
          var d1 = new Date();
          var d2 = null;
          if(this.product.flashSale && this.product.startDate){
            if(this.product.flashSaleStatus == "PENDING"){
                d2 = new Date(this.product.startDate);
            }else if(this.product.flashSaleStatus == "START"){
                d2 = new Date(this.product.startDate + (24*60*60*1000));
            }
            if(d2){
              var dif = d2.getTime() - d1.getTime();
              dif = dif / 1000;
              if(dif < 0){
                dif = 0;
              }
              this.count = dif;
              if(this.count > 86400){
                this.count -= 86400;
                this.day = true;
              }else{
                this.day = false;
              }
            }
          }
        }catch(err){
          
        }
        this.fiat$ = this.authService.fiat$.subscribe(fiat => {
          try{
            this.cd.detectChanges();
          }catch(err){

          }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.fiat$.unsubscribe();
    }

    addToCart(): void {
        if (this.addingToCart) {
            return;
        }

        this.addingToCart = true;
        this.cart.add(this.product, 1).subscribe({
            complete: () => {
                this.addingToCart = false;
                this.cd.markForCheck();
            }
        });
    }

    addToWishlist(): void {
        if (this.addingToWishlist) {
            return;
        }

        this.addingToWishlist = true;
        this.wishlist.add(this.product).subscribe({
            complete: () => {
                this.addingToWishlist = false;
                this.cd.markForCheck();
            }
        });
    }

    addToCompare(): void {
        if (this.addingToCompare) {
            return;
        }

        this.addingToCompare = true;
        this.compare.add(this.product).subscribe({
            complete: () => {
                this.addingToCompare = false;
                this.cd.markForCheck();
            }
        });
    }

    showQuickview(): void {
        if (this.showingQuickview) {
            return;
        }
        this.showingQuickview = true;
        this.product.custom = true;
        this.quickview.show(this.product).subscribe({
            complete: () => {
                this.showingQuickview = false;
                this.cd.markForCheck();
            }
        });
    }

    cartOrQuickview(){
      if(this.canAddToCart()){
        this.addToCart();
      }else{
        this.showQuickview();
      }
    }

    canAddToCart(){
      if(this.attributeList.length > 0){
        return false;
      }else{
        return true;
      }
    }

    goToMerchant(storeId){
      this.authService.router.navigate(['/classic/shop/merchant', storeId]);
    }

}
